export default __webpack_public_path__ + "static/media/top-bar.186b1fb2.png";